<!-- Header Section — kept outside the loading branch so searching doesn't drop focus -->
<div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
  <div>
    <h5 class="mb-1 fw-bold">Suppliers</h5>
    <span class="sub-text">Manage your raw material suppliers</span>
  </div>

  <div class="d-flex flex-wrap gap-2">
    @if (hasActiveFilters) {
      <button class="btn btn-secondary d-flex align-items-center gap-1" (click)="clearFilters()">
        <i class="bi bi-x-circle"></i>
        Clear
      </button>
    }

    <button class="btn btn-primary btn-enjochem" (click)="onAddNewSupplier()">
      <i class="bi bi-plus-circle"></i>
      <span>Add New Supplier</span>
    </button>
  </div>
</div>

<div class="row g-2 mb-4">
  <div class="col-12 col-md-8">
    <div class="input-group">
      <span class="input-group-text bg-white border-end-0">
        <i class="bi bi-search text-muted"></i>
      </span>
      <input
        type="text"
        class="form-control border-start-0 ps-0"
        placeholder="Search suppliers"
        aria-label="Search suppliers"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchChange($event)" />
    </div>
  </div>

  <div class="col-12 col-md-4">
    <ng-select
      placeholder="All Categories"
      [items]="categoryOptions"
      [(ngModel)]="selectedCategory"
      bindValue="value"
      bindLabel="label"
      [clearable]="true"
      [searchable]="true"
      (ngModelChange)="onCategoryChange()" />
  </div>
</div>

@if (isSupplierDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  <div class="table-responsive">
    @if (suppliers.length > 0) {
      <table class="table table-hover align-middle mb-0">
        <thead class="bg-light">
          <tr>
            <th class="ps-4 py-3">Supplier Name</th>
            <th class="py-3">Category</th>
            <th class="py-3">Firm Type</th>
            <th class="py-3">Responsible Person</th>
            <th class="py-3">GST No</th>
            <th class="py-3">Contact No</th>
            <th class="text-center py-3 pe-4">Actions</th>
          </tr>
        </thead>

        <tbody>
          @for (supplier of suppliers; track supplier.id) {
            <tr>
              <td class="fw-semibold text-dark">{{ supplier.name }}</td>
              <td>
                @if (supplier.category_name) {
                  <span class="app-badge badge-secondary">{{ supplier.category_name }}</span>
                } @else {
                  -
                }
              </td>
              <td class="ps-4 fw-semibold text-dark">
                {{ supplier.firm_type ? FirmTypeLabel[supplier.firm_type] : '-' }}
              </td>
              <td>{{ supplier.responsible_person || '-' }}</td>
              <td>
                <span class="app-badge badge-secondary">{{ supplier.gst_number || '-' }}</span>
              </td>
              <td>{{ supplier.phone_number || '-' }}</td>
              <td class="text-center pe-4">
                <div class="d-flex flex-row gap-2 justify-content-center">
                  <button class="btn btn-action-edit" (click)="editSupplier(supplier)" title="Edit">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="btn btn-action-delete" (click)="deleteSupplier(supplier)" title="Delete">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else if (hasActiveFilters) {
      <div class="empty-state-container">
        <i class="bi bi-search"></i>
        <h5>No Matching Suppliers</h5>
        @if (searchTerm.trim()) {
          <p>No supplier matches "{{ searchTerm }}".</p>
        } @else {
          <p>No supplier is in this category.</p>
        }
        <button class="btn btn-outline-primary" (click)="clearFilters()">Clear filters</button>
      </div>
    } @else {
      <div class="empty-state-container">
        <i class="bi bi-shop"></i>
        <h5>No Suppliers Found</h5>
        <p>Get started by adding your first supplier to the system.</p>
        <button class="btn btn-outline-primary" (click)="onAddNewSupplier()">+ Add New Supplier</button>
      </div>
    }
  </div>

  @if (suppliers && suppliers.length > 0) {
    <div class="mt-4">
      <app-pagination
        [currentPage]="currentPage"
        [totalCount]="totalCount"
        [pageSize]="10"
        [hasNextPage]="hasNextPage"
        [hasPreviousPage]="hasPreviousPage"
        (pageChange)="onPageChange($event)"></app-pagination>
    </div>
  }
}

<ng-template #addNewSupplierContent>
  <div class="modal-content border-0">
    <div class="modal-header">
      <div>
        <h5 class="modal-title mb-1">
          {{ supplierToBeEdit ? 'Update Supplier' : 'Add New Supplier' }}
        </h5>
        <div class="sub-text small">Please fill in all the required fields to save the Supplier's information.</div>
      </div>
      <button type="button" class="btn-close" (click)="modalRef.close()" aria-label="Close"></button>
    </div>

    <div class="modal-body p-0">
      <app-supplier-info-form
        [supplier]="supplierToBeEdit"
        [mode]="supplierToBeEdit ? Action.EDIT : Action.CREATE"
        (onCancelEvent)="modalRef.close()"
        (onSaveEvent)="onSaveSupplierInfo($event)" />
    </div>
  </div>
</ng-template>
